var render = function render(){
  var _vm$fleets, _vm$fleets2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100 mt-4"
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("FLEET REPORT (CURRENT CONDITION)")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [!_vm.loading ? _c('div', {
          staticClass: "d-flex overflow-auto pb-3"
        }, _vm._l(_vm.fleetReports, function (item, index) {
          var _vm$fleetsStatus$find, _item$data, _item$data2;
          return _c('div', {
            key: index,
            staticClass: "card-container cursor-pointer shadow-sm",
            staticStyle: {
              "min-width": "24%",
              "margin-right": "1%"
            },
            attrs: {
              "md": "".concat(item.cols * 2)
            }
          }, [_c('div', {
            directives: [{
              name: "b-toggle",
              rawName: "v-b-toggle",
              value: "collapse-fleet-report-".concat(index),
              expression: "`collapse-fleet-report-${index}`"
            }],
            staticClass: "p-2 py-3 card-title-wrap d-flex align-items-center px-3",
            class: (_vm$fleetsStatus$find = _vm.fleetsStatus.find(function (i) {
              return i.title == item.title;
            })) === null || _vm$fleetsStatus$find === void 0 ? void 0 : _vm$fleetsStatus$find.bg,
            staticStyle: {
              "border-radius": "10px"
            }
          }, [_c('div', [_c('strong', {
            staticClass: "p-0 m-0 text-yellow"
          }, [_vm._v(_vm._s(item.title))]), _c('h4', {
            staticClass: "text-white"
          }, [_vm._v(_vm._s(item.detail) + " Fleets")])])]), item.title == 'Heavy Equipment' ? _c('img', {
            staticClass: "card-image",
            staticStyle: {
              "top": "34px"
            },
            attrs: {
              "src": require("../../../assets/images/icon/heavy-equipment.svg"),
              "width": "90",
              "alt": ""
            }
          }) : _c('img', {
            staticClass: "card-image",
            attrs: {
              "src": require("../../../assets/images/icon/ship-3d.png"),
              "width": "78",
              "alt": ""
            }
          }), _c('b-collapse', {
            attrs: {
              "id": "collapse-fleet-report-".concat(index)
            }
          }, [_c('div', {
            staticClass: "mt-2"
          }, [item.title == 'Heavy Equipment' ? [_c('div', {
            staticClass: "py-1 px-3 d-flex justify-content-between bg-striped"
          }, [_c('h6', [_vm._v("Active")]), _c('h6', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$data = item.data) === null || _item$data === void 0 ? void 0 : _item$data.active))])]), _c('div', {
            staticClass: "py-1 px-3 d-flex justify-content-between"
          }, [_c('h6', [_vm._v("Breakdown")]), _c('h6', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : (_item$data2 = item.data) === null || _item$data2 === void 0 ? void 0 : _item$data2.breakdown))])])] : _vm._l(item.data, function (tableData, i) {
            return _c('div', {
              key: i,
              staticClass: "py-1 px-3 d-flex justify-content-between",
              class: {
                'bg-striped': i % 2 == 0
              },
              on: {
                "click": function click() {
                  return _vm.showDetailFleet(tableData);
                }
              }
            }, [_c('h6', [_vm._v(_vm._s(tableData.name))]), _c('h6', [_vm._v(_vm._s(tableData.total_vehicle))])]);
          })], 2)])], 1);
        }), 0) : _c('div', {
          staticClass: "d-flex w-100 justify-content-center my-5"
        }, [_c('b-spinner', {
          staticStyle: {
            "height": "80px",
            "width": "80px"
          }
        })], 1)];
      },
      proxy: true
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "add-init",
      "size": "xl",
      "title": "FLEETS",
      "header-bg-variant": "light",
      "header-text-variant": "dark",
      "footer-bg-variant": "light",
      "footer-text-variant": "dark"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var cancel = _ref.cancel;
        return [_c('b-row', [_c('b-col', {
          staticClass: "text-center",
          attrs: {
            "md": "12"
          }
        }, [_c('b-button', {
          staticClass: "iq-bg-danger text-right",
          attrs: {
            "variant": "none"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Cancel")]), _vm.page > 1 ? _c('b-button', {
          staticClass: "ml-2 text-right",
          attrs: {
            "variant": "secondary",
            "disabled": _vm.page <= 1
          },
          on: {
            "click": _vm.prevPage
          }
        }, [_c('span', [_vm._v("Back "), _c('i', {
          staticClass: "fa fa-arrow-left"
        })])]) : _vm._e(), _c('b-button', {
          staticClass: "ml-2 text-right",
          attrs: {
            "type": "submit",
            "variant": "primary",
            "disabled": _vm.totalPages === 1
          },
          on: {
            "click": _vm.nextPage
          }
        }, [_vm.nextLoading ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : _c('span', [_vm._v("Next "), _c('i', {
          staticClass: "fa fa-arrow-right"
        })])])], 1)], 1)];
      }
    }]),
    model: {
      value: _vm.showModalDetailFleet,
      callback: function callback($$v) {
        _vm.showModalDetailFleet = $$v;
      },
      expression: "showModalDetailFleet"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "80vh",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('b-row', {
    staticClass: "mb-4 align-items-end"
  }, [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Search fleets..."
    },
    on: {
      "input": _vm.onSearchInput
    },
    model: {
      value: _vm.searchFleet,
      callback: function callback($$v) {
        _vm.searchFleet = $$v;
      },
      expression: "searchFleet"
    }
  })], 1), _c('b-col', {
    staticClass: "d-flex justify-content-end align-items-center",
    attrs: {
      "md": "8"
    }
  }, [_c('h6', {
    staticClass: "mr-2 mb-0"
  }, [_vm._v("View :")]), _c('b-button-group', [_c('b-button', {
    staticClass: "p-2 px-3 button-view",
    attrs: {
      "variant": _vm.modalView === 'list' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function click($event) {
        _vm.modalView = 'list';
      }
    }
  }, [_c('i', {
    staticClass: "fa m-0 fa-bars"
  })]), _c('b-button', {
    staticClass: "p-2 px-3 button-view",
    attrs: {
      "variant": _vm.modalView === 'large' ? 'primary' : 'outline-primary'
    },
    on: {
      "click": function click($event) {
        _vm.modalView = 'large';
      }
    }
  }, [_c('i', {
    staticClass: "fa m-0 fa-th-large"
  })])], 1)], 1)], 1), _vm.loading_fleet ? _c('div', {
    staticClass: "text-center my-5"
  }, [_c('b-spinner', {
    attrs: {
      "type": "grow",
      "label": "Spinning"
    }
  })], 1) : [_vm.modalView === 'large' && ((_vm$fleets = _vm.fleets) === null || _vm$fleets === void 0 ? void 0 : _vm$fleets.length) > 0 ? _c('b-row', _vm._l(_vm.fleets, function (fleet, i) {
    return _c('b-col', {
      key: "fleet-".concat(i),
      staticClass: "text-center py-5 border-top",
      attrs: {
        "md": "3"
      }
    }, [_c('div', {
      staticClass: "custom-control custom-radio image-checkbox"
    }, [_c('label', {
      staticClass: "custom-control-label",
      attrs: {
        "for": "ck-fl-".concat(i)
      }
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": _vm._f("checkPhoto")(fleet.vehicleType.icon.url, require('@src/assets/images/fleet/PusherBarge.png')),
        "alt": "#"
      }
    })]), _c('small', [_c('strong', [_vm._v(_vm._s(fleet.name))])])])]);
  }), 1) : _vm.modalView === 'list' && ((_vm$fleets2 = _vm.fleets) === null || _vm$fleets2 === void 0 ? void 0 : _vm$fleets2.length) > 0 ? _c('div', {
    staticClass: "border-top overflow-auto"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped mb-0"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _c('th', [_vm._v("Type")]), _c('th', [_vm._v("Code")]), _c('th', [_vm._v("Status")])])]), _c('tbody', _vm._l(_vm.fleets, function (fleet, i) {
    var _fleet$vehicleType;
    return _c('tr', {
      key: "fleet-row-".concat(i)
    }, [_c('td', [_vm._v(_vm._s(fleet.name))]), _c('td', [_vm._v(_vm._s(((_fleet$vehicleType = fleet.vehicleType) === null || _fleet$vehicleType === void 0 ? void 0 : _fleet$vehicleType.name) || '-'))]), _c('td', [_vm._v(_vm._s(fleet.code || '-'))]), _c('td', [_c('b-badge', {
      attrs: {
        "variant": fleet.active ? 'success' : 'secondary'
      }
    }, [_vm._v(_vm._s(fleet.active ? 'Active' : 'Inactive'))])], 1)]);
  }), 0)])])]) : _c('div', {
    staticClass: "text-center my-5"
  }, [_c('p', {
    staticClass: "mb-0 text-muted"
  }, [_vm._v("No fleets data found.")])])]], 2)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }